<template>
  <div class="groundwater-information-widget">
    <div class="groundwater-information-title">
      <h2>{{ $t('tableTitles.GroundWaterInfo') }}</h2>
    </div>
    <div class="groundwater-information-widget-container">
      <groundWaterDataTableOverview
        :enableCreateTableRowAction="enableCreateTableRowAction"
        :enableDeleteTableRowAction="enableDeleteTableRowAction"
        :enableUpdateTableRowAction="enableUpdateTableRowAction"
        :enableColumnChooser="enableColumnChooser"
        :searchPanelEnabled="searchPanelEnabled"
        :enableExportSettings="enableExportSettings"
      />
    </div>
  </div>
</template>
<script>
import groundWaterDataTableOverview from '@/components/table-overviews/groundWaterDataTableOverview'
export default {
  name: 'groundWaterInfoWidget',
  components: {
    groundWaterDataTableOverview
  },
  data() {
    return {
      enableCreateTableRowAction: false,
      enableDeleteTableRowAction: false,
      enableUpdateTableRowAction: false,
      enableColumnChooser: false,
      searchPanelEnabled: false,
      enableExportSettings: false,
      projectCode: ''
    }
  }
}
</script>
<style lang="less" scoped>
.groundwater-information-widget {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .groundwater-information-title h2 {
    display: flex;
    justify-content: center;
    margin: 0 0 15px 0;
    font-size: 24px;
    padding-bottom: 15px;
    color: #89b368;
    border-bottom: 1px solid #d5d5d5;
  }
  .groundwater-information-widget-container {
    display: flex;
    flex-direction: column;
    height: 85%;
    width: 100%;
  }
}
</style>
